
import React from 'react';
import { Drawer, Box, Divider } from '@mui/material';

const NotificationDrawer = ({ open, toggleDrawer, togglekey }) => {

  const notificationKey = 'NotificationKey';
  const helFileKey = 'HelpFileKey';

  const getNotificationContent = () => {
    return (
      <div class="notification-container">
        <div class="notification-section">
          <div class="notification-title">Announcements</div>
          <div class="notification-content">The documents will be available for the download after 2 business days</div>
          <div class="notification-content">Administrators were notified of this change last week</div>
        </div>
        <div class="notification-section">
          <div class="notification-title">Production Release</div>
          <div class="notification-content">The latest version will be launced after Thanksgiving week!</div>
        </div>
      </div>
    );
  }

  const getHelpFileContent = () => {
    return (
      <div class="notification-container">
        <div class="notification-section">
          <div class="notification-title">Intake Workflow</div>
          <div class="notification-content">Receive application/referral and determine if valid. Create the case in the state system.</div>
        </div>
        <div class="notification-section">
          <div class="notification-title">Create Case Record or Escalate</div>
          <div class="notification-content">The workflow has to be initiated soon</div>
        </div>
      </div>
    );
  }

  const getToggleDrawerContent = (key) => {
    switch (key) {
      case notificationKey:
        return getNotificationContent();
      case helFileKey:
        return getHelpFileContent();
      default:
        return getNotificationContent();
    }
  }

  return (
    <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
      <Box sx={{ width: 350, height: '100%', backgroundColor: '#131E42' }} role="presentation" >
        {getToggleDrawerContent(togglekey)}
      </Box>
    </Drawer>
  );

};

export default NotificationDrawer;
